import { useQuery } from "@tanstack/react-query";
import { motion } from "framer-motion";
import { CalendarDays, Loader2, BookOpen, Video } from "lucide-react";
import { DashboardShell } from "@/components/DashboardShell";
import { LessonCard } from "@/components/LessonCard";
import { api } from "@/lib/api";

const nav = [{ label: "My Lessons", href: "#lessons", icon: CalendarDays }];

export default function StudentDashboard() {
  const { data: lessons = [], isLoading } = useQuery({ queryKey: ["lessons"], queryFn: async () => (await api.get("/lessons")).data });
  const confirmed = lessons.filter((l) => l.payment_status === "paid");

  return (
    <DashboardShell title="Student Dashboard" subtitle="Your upcoming lessons" nav={nav}>
      <div className="rounded-2xl border border-slate-200 bg-white p-6 mb-8 flex items-center justify-between">
        <div>
          <p className="text-sm text-slate-500">Confirmed lessons</p>
          <p className="font-display text-3xl font-bold text-[#595C2B] mt-1">{confirmed.length}</p>
        </div>
        <BookOpen className="h-8 w-8 text-[#BA8A30]" />
      </div>

      <section id="lessons">
        <h2 className="font-display text-2xl font-semibold text-[#595C2B] mb-4">Your lessons</h2>
        {isLoading ? <Loader2 className="h-6 w-6 animate-spin text-[#595C2B]" /> : lessons.length === 0 ? (
          <div className="rounded-2xl border border-dashed border-slate-300 bg-white p-10 text-center text-slate-500">
            <Video className="h-8 w-8 mx-auto text-slate-300 mb-2" />
            No lessons yet. Ask your parent to book a lesson using your email address.
          </div>
        ) : (
          <div className="grid md:grid-cols-2 gap-4">
            {lessons.map((l, i) => (
              <motion.div key={l.id} initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05 }}>
                <LessonCard lesson={l} who="student" />
              </motion.div>
            ))}
          </div>
        )}
      </section>
    </DashboardShell>
  );
}
